import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from "react-router-dom";

import Login from "../pages/login/Login";
import Join from "../pages/join/Join";
import Dashboard from "../pages/dashboard/Dashboard";
import PrivateRoute from "./PrivateRoute";
import Stock from "../pages/stock/Stock";
import AutoTrading from "../pages/auto/AutoTrading";
import TradeLog from "../pages/log/TradeLog";
import Setting from "../pages/setting/Setting";

function Router() {

    const token = localStorage.getItem("accessToken");

    return (

        <BrowserRouter>

            <Routes>

                {/* 첫 접속 */}
                <Route
                    path="/"
                    element={
                        token
                            ? <Navigate to="/dashboard" replace />
                            : <Navigate to="/login" replace />
                    }
                />

                {/* 로그인 */}
                <Route
                    path="/login"
                    element={<Login />}
                />

                {/* 회원가입 */}
                <Route
                    path="/join"
                    element={<Join />}
                />

                {/* 대시보드 */}
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />

                <Route
    path="/stock"
    element={
        <PrivateRoute>
            <Stock />
        </PrivateRoute>
    }
/>

<Route
    path="/auto"
    element={
        <PrivateRoute>
            <AutoTrading />
        </PrivateRoute>
    }
/>

<Route
    path="/log"
    element={
        <PrivateRoute>
            <TradeLog />
        </PrivateRoute>
    }
/>

<Route
    path="/setting"
    element={
        <PrivateRoute>
            <Setting />
        </PrivateRoute>
    }
/>

                {/* 잘못된 주소 */}
                <Route
                    path="*"
                    element={<Navigate to="/" replace />}
                />

            </Routes>

        </BrowserRouter>

    );

}

export default Router;